export default {
    namespaced: true,
    state: {
        mimeAcceptes: ["application/pdf", "image/jpeg", "image/jpg", "image/png"],
        journaux: [],
        tribunaux: [],
        tailleFichierMax: 3 * 1024 * 1024,
        tailleMax: 10 * 3 * 1024 * 1024,
        environnement: null,
        lienCGU: null,
        lienFAQ: null,
        lienGuideAMA: null,
    },

    getters: {
        mimeAcceptes(state) {
            return state.mimeAcceptes;
        },
        tailleFichierMax(state) {
            return state.tailleFichierMax;
        },
        tailleMax(state) {
            return state.tailleMax;
        },
        journaux(state) {
            return state.journaux;
        },
        tribunaux(state) {
            return state.tribunaux;
        },
        environnement(state) {
            return state.environnement;
        },
        lienCGU(state) {
            return state.lienCGU;
        },
        lienFAQ(state) {
            return state.lienFAQ;
        },
        lienGuideAMA(state) {
            return state.lienGuideAMA;
        },
    },

    mutations: {
        init(state, { mimeAcceptes, tailleMax, tailleFichierMax, journaux, tribunaux, environnement, lienCGU, lienFAQ, lienGuideAMA }) {
            state.mimeAcceptes = mimeAcceptes;
            state.tailleMax = tailleMax;
            state.tailleFichierMax = tailleFichierMax;
            state.journaux = journaux;
            state.tribunaux = tribunaux;
            state.environnement = environnement;
            state.lienCGU = lienCGU;
            state.lienFAQ = lienFAQ;
            state.lienGuideAMA = lienGuideAMA;
        },
    },
}
